let dateServer = value => {
    return value.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
};

let phoneSensitive = value => {
    if (!value) return value;
    return value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
};

let bankSensitive = value => {
    if (!value) return value;
    value = value.slice(value.length - 4, value.length);
    return '**** **** **** ' + value;
};

/*
* number：要格式化的数字
* decimals：保留几位小数
* dec_point：小数点符号
* thousands_sep：千分位符号
* */
let amountFormat = (number = 0, decimals = 2, dec_point = '.', thousands_sep = ',') => {
    number = (number + '').replace(/[^0-9+-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.ceil(n * k) / k;
        };
 
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    var re = /(-?\d+)(\d{3})/;
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
    }
 
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

let dateFormat = str => {
    // format yyyy-mm-dd to yyyy/mm/dd
    return str.replace(/\-/g, '/');
}

export { dateServer, phoneSensitive, bankSensitive, amountFormat, dateFormat }



// WEBPACK FOOTER //
// ./src/common/filters/custom.js